import transferInner from './index';

export default { path: '/home/transferInner', component: transferInner };
